import React from 'react';

const TimelineNoteIcon = ({ fill = 'grey'}) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 13 13"
      xmlSpace="preserve"
      className="card-icon"
    >
      <title>Note Added</title>
      <desc>Created with Sketch.</desc>
      <g id="Case-Details---New">
        <g id="Case-Details---Timeline" transform="translate(-863.000000, -1909.000000)">
          <g id="Timeline" transform="translate(255.000000, 777.000000)">
            <g id="Timeline-Items" transform="translate(277.000000, 107.000000)">
              <g id="Note-Added" transform="translate(317.000000, 1005.000000)">
                <g id="Icon">
                  <g id="Avatar">
                    <path
                      id="Shape"
                      fill={fill}
                      d="M26.6,23.6l-1.2,1.2c-0.1,0.1-0.3,0.1-0.4,0L22.2,22c-0.1-0.1-0.1-0.3,0-0.4l1.2-1.2
                      c0.5-0.5,1.2-0.5,1.7,0l1.5,1.5C27.1,22.4,27.1,23.1,26.6,23.6z M21.2,22.5l-6.7,6.7L14,32.3c-0.1,0.4,0.3,0.8,0.7,0.7
                      l3.1-0.5l6.7-6.7c0.1-0.1,0.1-0.3,0-0.4l-2.8-2.8C21.5,22.4,21.3,22.4,21.2,22.5z M16.2,30.8h1.2v0.9L15.8,32L15,31.2
                      l0.3-1.6h0.9V30.8z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TimelineNoteIcon;
